module.exports = __webpack_public_path__ + "static/media/gabriela_barbulescu.6030f49d.jpg";